// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoModal-module__title--3SYVJ","heading":"InfoModal-module__heading--2N15_","text":"InfoModal-module__text--2xn8W","footer":"InfoModal-module__footer--1pw9V"};